import { makeEntityScaffold } from '@classpass/saga-tools';
import { transformV2ClientResponse, transformKeysToSnakeCase } from 'helpers/core';
import URLS from 'constants/urls';

const methods = {
  create: (httpClient, venueId, payload) => {
    return httpClient.post(URLS.venue.videos.create(venueId), transformKeysToSnakeCase(payload));
  },
  delete: (httpClient, venueId, payload) => {
    const { id } = payload;
    return httpClient.delete(URLS.venue.videos.delete(venueId, id), transformKeysToSnakeCase(payload));
  },
  read: (httpClient, venueId) => {
    return httpClient
      .get(URLS.venue.videos.read(venueId))
      .then(transformV2ClientResponse)
      .then(data => data?.externalVideos ?? []);
  },
  update: (httpClient, venueId, payload) => {
    const { id } = payload;
    return httpClient.patch(URLS.venue.videos.update(venueId, id), transformKeysToSnakeCase(payload));
  },
  batch: (httpClient, venueId, updatesByMethod) => {
    const promises = Object.entries(updatesByMethod).flatMap(([method, updates]) =>
      updates.map(video => methods[method](httpClient, venueId, video))
    );
    return Promise.all(promises).then(() => methods.read(httpClient, venueId));
  },
};

const handler = ({ httpClient }, method = 'read', venueId, payload) => methods[method](httpClient, venueId, payload);

export default makeEntityScaffold('SAGA.API.VENUE_VIDEOS', handler, {
  defaultKey: (_, __, venueId = 'default') => venueId,
  method: Object.keys(methods).reduce((acc, method) => ({ ...acc, [method]: method }), {}),
});
